import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { BreakpointMobile, PathnamesMap } from '../../constants/ui';
import { useViewport } from '../../hooks';
import { Header } from '../../components';
import { Sensor } from '../../components/Sensor/index.jsx';

const SensorPage = ({ type }) => {
  const { t } = useTranslation();
  const { widthViewport } = useViewport();
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(`/${PathnamesMap.dashboard}`);
  };

  return (
    <>
      {widthViewport > BreakpointMobile && (
        <Header
          t={t}
          withBackButton={true}
          backButtonText={t('actions.backToDashboard')}
          onBackButton={() => handleBack()}
        />
      )}
      <main className="main">
        <Sensor t={t} type={type} />
      </main>
    </>
  );
};

export default SensorPage;
